module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idea-card container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "reviews"
  }, [_c('div', {
    staticClass: "container idea-page"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2 back-remove"
  }, [_c('button', {
    staticClass: "button-back",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', [_vm._v("Назад")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "remove-link"
  }), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Добавление идеи")]), _vm._v(" "), _c('form', {
    staticClass: "form-plus-idea",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createIdea($event)
      }
    }
  }, [_c('input', {
    staticClass: "style-input",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Название идеи"
    },
    domProps: {
      "value": _vm.title
    },
    on: {
      "blur": function($event) {
        _vm.searchSimiliars($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.searchResults) ? _c('div', {
    staticClass: "help-blocks"
  }, [_c('ul', [_c('li', {
    staticClass: "help-block-title"
  }, [_vm._v("Похожие темы")]), _vm._v(" "), _vm._l((_vm.searchResults.byTitle), function(result) {
    return _c('li', {
      staticClass: "help-block-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'idea',
          params: {
            id: result.id
          }
        }
      }
    }, [_vm._v("\n                                            Удаление аккаунта\n                                        ")])], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "arrow-select"
  }, [_c('div', {
    staticClass: "style-input turn",
    class: {
      active: _vm.showSelect, empty: !_vm.category_id
    },
    on: {
      "click": function($event) {
        _vm.showSelect = !_vm.showSelect
      }
    }
  }, [_c('span', {
    staticClass: "placeholer-element"
  }, [_vm._v(_vm._s(_vm.categoryName))]), _vm._v(" "), _c('span', {
    staticClass: "btton-push-cat"
  }), _vm._v(" "), (_vm.showSelect) ? _c('ul', {
    staticClass: "select-category"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.chooseCategory(cat)
        }
      }
    }, [(cat.parent_id) ? _c('span', [_vm._v("   ‐ ")]) : _vm._e(), _vm._v(_vm._s(cat.title) + "\n                                        ")])
  })) : _vm._e()]), _vm._v(" "), (_vm.showSelect) ? _c('div', {
    staticClass: "arrow-select-bg",
    on: {
      "click": function($event) {
        _vm.showSelect = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('Editor', {
    attrs: {
      "placeholder": "Описание",
      "content": _vm.descriptionHtml
    },
    on: {
      "change": _vm.setDescription,
      "ctrl-enter": _vm.createIdea
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "desc-notice"
  }, [_vm._v("\n                                Пожалуйста, опишите вашу идею как можно подробнее.\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('привет'),
      expression: "'привет'"
    }],
    staticClass: "button",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsCorrect,
      "title": _vm.formIsCorrect ? '' : 'Заполните, пожалуйста, все поля.'
    }
  }, [_vm._v("\n                                    Разместить идею\n                                ")]), _vm._v(" "), _c('em', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('test'),
      expression: "'test'"
    }],
    staticClass: "button-help"
  }, [_vm._v("\n                                    Все поля обязательны к заполнению.\n                                ")])])], 1), _vm._v(" "), _vm._m(0, false, false)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "form-info"
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" Все объявления проходят обязательно модерацию для проверки корректности вводимой информации\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0a5901c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IdeaCreate.vue
// module id = 117
// module chunks = 0